import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '@lili/lili-frontend-common';
import { RoleType, TeamMember } from '../../../../../types';

interface RoleItemUserRoleProps {
  teamMember: TeamMember;
}

export const RoleItemUserRole = ({ teamMember }: RoleItemUserRoleProps) => {
  const { t } = useTranslation();
  const roleName = useMemo(() => {
    switch (teamMember.teamMemberType) {
      case RoleType.ADMIN:
        return t('ACCOUNT_SETTINGS.TEAM.TABLE.ROLE_TYPE.ADMIN');
      case RoleType.ACCOUNTANT:
        return t('ACCOUNT_SETTINGS.TEAM.TABLE.ROLE_TYPE.ACCOUNTANT');
      case RoleType.UBO:
        return t('ACCOUNT_SETTINGS.TEAM.TABLE.ROLE_TYPE.UBO');
      default:
        return '';
    }
  }, [teamMember]);
  return (
    <div className='flex flex-col '>
      <div className='flex flex-col'>
        <Heading.H10 className='text-text-main-primary '>{roleName}</Heading.H10>
      </div>
    </div>
  );
};
